import React from 'react';

export default function DropzoneUploadOverlay(props) {

    return (
        <div className={props.className} id={props.nodeId}>
            <div className="tip-tile">

                <div className="i5-download"> </div>
                <h1>Drop Files Here</h1>
            </div>

            <div id="tip-overlay-id" className="tip-overlay"> </div>
        </div>

    );

}
//
// class DropzoneUploadOverlay extends React.Component {
//     render() {
//         return (
//             <div className={this.props.className} id={this.props.nodeId}>
//                 <div className="tip-tile">
//
//                     <div className="i5-download"> </div>
//                     <h1>Drop Files Here</h1>
//                 </div>
//
//                 <div id="tip-overlay-id" className="tip-overlay"> </div>
//             </div>
//
//         );
//     }
// }
//
// module.exports = DropzoneUploadOverlay;